export default __webpack_public_path__ + "static/media/bootstrap.6bc1e714.png";